// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"0c41c30b","504":"c8ba5c7c","749":"c8ba5c7c"}[chunkId] + ".chunk.css";
};